export var Paths;

(function (Paths) {
  Paths["ListVideos"] = "/me/watch_later";
  Paths["AddVideo"] = "/me/watch_later/:videoId";
  Paths["RemoveVideo"] = "/me/watch_later/:videoId";
  Paths["GetVideoCount"] = "/me/watch_later/unwatched_count";
})(Paths || (Paths = {}));